import * as React from 'react';
import { useSelector } from 'react-redux';

import { LayoutBlock } from '../../components/LayoutBlock';
import { getIsMapVisible } from '../../selectors/common';
import { InfrastructureMicrofrontendContainer } from '../InfrastructureMicrofrontendContainer';
import { NearbyNewbuildingsLinkContainer } from '../NearbyNewbuildingsLink';
import { SpecialPromoLinkContainer } from '../SpecialPromoLink';

export const InfrastructureContainer = () => {
  const isMapVisible = useSelector(getIsMapVisible);

  if (!isMapVisible) {
    return null;
  }

  return (
    <LayoutBlock>
      <InfrastructureMicrofrontendContainer
        headerLinks={
          <>
            <SpecialPromoLinkContainer />
            <NearbyNewbuildingsLinkContainer />
          </>
        }
      />
    </LayoutBlock>
  );
};
